import React from 'react';
import { profile } from '../data/profile';
import SocialLinks from './SocialLinks';

function Header() {
  return (
    <header className="header">
      <h1 className="header__name">{profile.name}</h1>
      <p className="header__tagline">{profile.tagline}</p>
      <SocialLinks />
    </header>
  );
}

export default Header;
